export default __webpack_public_path__ + "static/media/mockup-tetris.213ef0ef.png";